import 'bootstrap-slider';
import 'select2';
import CONFIG from 'core/Config';
import common from 'routes/common';
import BreakpointSniffer from 'utils/BreakpointSniffer';
import compareBar from 'modules/compareBar';
import FilterCarousel from 'modules/filterCarousel';
import ProductPreselect from 'modules/productPreselect';

export default (function() {
	const filterUrl = window.location.href;
	const pageTitle = document.title;

	let clearFilter;
	let filterNav;
	let quickFilters;
	let filterParent;
	let filterResults;
	let toggleNav;
	let seoText;
	let pagination;
	let filters;
	let priceSlider;
	let priceRange;
	let priceName;
	let priceMin;
	let priceMax;
	let filterIsOpen = false;
	let _isLoading = false;
	let collapsed = [];
	let _currentState = {
		id: 0
	};

	let filterState     = window.theme.shop_cur_filters || {};
	const filterLinks   = window.theme.shop_links;
	const filterOrder   = window.theme.shop_vars || [];
	filterOrder.push('orderby');

	function init() {
		// Init filters
		initFilters();

		// Listens to back & prev buttons in browser
		addToHistory(filterUrl, pageTitle);
		window.addEventListener('popstate', onPopState);

		// Uncollapse toggles on desktop
		$(window).on('resize orientationchange', onResize);
		onResize();
	}

	function initFilters() {
		filterNav     = '.js-filter-nav';
		quickFilters  = $('.js-quick-filter');
		seoText       = '.js-product-content';
		filterResults = '.js-filter-results';
		filterParent  = $('.js-nav-parent');
		toggleNav     = $('.js-toggle-nav-filter');
		clearFilter   = $('.js-clear-filter');
		pagination    = $('.woocommerce-pagination a.page-numbers');
		filters       = $('.js-nav-filter');
		priceSlider   = $('input.js-price-range').slider();
		priceName     = $('input.js-price-range').attr('name');
		priceMin      = $('.js-price-range-min');
		priceMax      = $('.js-price-range-max');
		priceRange    = priceSlider.slider('getValue');

		// Toggle Mobile Filter Nav
		toggleNav.on('click', (e) => {
			e.preventDefault();
			toggleFilterNav();
		});

		// Orderby (frontend/woocommerce.js needs to be dequeued in order to override this)
		$(`.js-sortby-select, ${filterResults}`).find('.woocommerce-ordering').on('change', 'select.orderby', (e) => {
			e.preventDefault();
			const orderby = $(e.currentTarget).val();

			// Update state
			filterState.orderby = orderby;

			const newUrl = constructFilterUrl(filterState);
			addToHistory(newUrl, pageTitle);
			loadResults(newUrl);
		});

		$('.js-sort-link').on('click', (e) => {
			e.preventDefault();
			const orderby = $(e.target).data('value');

			// Update state
			filterState.orderby = orderby;

			const newUrl = constructFilterUrl(filterState);
			addToHistory(newUrl, pageTitle);
			loadResults(newUrl, () => toggleFilterNav());
		});

		// Pagination
		pagination.on('click', (e) => {
			e.preventDefault();

			const newUrl   = $(e.currentTarget).attr('href');
			addToHistory(newUrl,  document.title);
			loadResults(newUrl);
		});

		// Clear
		clearFilter.on('click', (e) => {
			e.preventDefault();

			filterState = {};
			const clearUrl = window.theme.shop_url;

			addToHistory(clearUrl, pageTitle);
			loadResults(clearUrl);
		});

		// Checkboxes
		filters.each((i, f) => {
			$(f).find('input[type=checkbox]').on('change', (e) => {
				const tax   = $(e.currentTarget).attr('name');
				const value = $(e.currentTarget).val();

				if ($(e.currentTarget).is(':checked')) {
					if (!(tax in filterState)) {
						filterState[tax] = [value];
					} else {
						filterState[tax].push(value);
					}

				// Remove value to state
				} else {
					const index = filterState[tax].indexOf(value);
					if (index > -1) {
						filterState[tax].splice(index, 1);
					}
				}

				const newUrl = getFilterLink(filterState) || constructFilterUrl(filterState);
				addToHistory(newUrl, pageTitle);
				loadResults(newUrl);
			});

			// Multi-range
			$(f).find(priceSlider).on('slideStop', (e) => {
				priceRange = e.value;
				priceMin.val(priceRange[0]);
				priceMax.val(priceRange[1]);

				// Update state
				filterState[`${priceName}`] = priceRange;

				const newUrl = constructFilterUrl(filterState);
				addToHistory(newUrl, pageTitle);
				loadResults(newUrl);
			});

			$(f).find(priceMin).on('blur', onChangePriceRange);
			$(f).find(priceMax).on('blur', onChangePriceRange);
			$(f).find(priceMin).on("keypress", function(e){
				if (e.key == 'Enter') {
					onChangePriceRange();
				}
			});
			$(f).find(priceMax).on("keypress", function(e){
				if (e.key == 'Enter') {
					onChangePriceRange();
				}
			});
		});

		// Quick filter
		initQuickFilters(quickFilters);

		$(window).on('reset_quick_filters', e => {
			initQuickFilters(quickFilters);
		});
	}

	function initQuickFilters(quickFilters) {
		quickFilters.on('click', e => {
			e.preventDefault();

			const tax   = $(e.currentTarget).data('name');
			const value = $(e.currentTarget).data('value');

			if (!(tax in filterState)) {
				filterState[tax] = [value];
			} else {
				filterState[tax].push(value);
			}

			const newUrl = getFilterLink(filterState) || constructFilterUrl(filterState);
			addToHistory(newUrl, pageTitle);
			loadResults(newUrl);
		});
	}

	function onChangePriceRange(e = null) {
		if (e) {
			e.preventDefault();
		}

		priceRange = [
			priceMin.val(),
			priceMax.val()
		];

		if (filterState[`${priceName}`] != priceRange) {
			// Update state
			filterState[`${priceName}`] = priceRange;

			const newUrl = constructFilterUrl(filterState);
			addToHistory(newUrl, pageTitle);
			loadResults(newUrl);
		}

	}

	function onResize() {
		initNavCollapse();
	}

	function initNavCollapse() {
		const collapseParent = filterParent.attr('id');

		// Show all active collapse on desktop
		if (BreakpointSniffer.isBigger('lg')) {
			$(filterNav).find('.collapse').removeAttr('data-parent');
			if (collapsed.length > 0) {
				const activeCollapsed = $('#' + collapsed.join(',#'));
				activeCollapsed.addClass('no-transition').collapse('show').removeClass('no-transition');
			} else {
				$(filterNav).find('.collapse').addClass('no-transition').collapse('show').removeClass('no-transition');
			}
		// Hide all collapse in mobile menu except active
		} else {
			$(filterNav).find('.collapse').attr('data-parent', `#${collapseParent}`);
			if (collapsed.length > 0) {
				const activeCollapsed = $('#' + collapsed.join(',#'));
				$(filterNav).find('.collapse').not(activeCollapsed).collapse('hide');
				activeCollapsed.addClass('no-transition').collapse('show').removeClass('no-transition');
			} else {
				$(filterNav).find('.collapse').collapse('hide');
			}
		}
	}

	function toggleFilterNav() {
		filterIsOpen = !filterIsOpen;
		if (!$('body').hasClass('filter-nav-open')) {
			$('body').addClass('filter-nav-open');
		} else {
			$('body').removeClass('filter-nav-open');
		}
	}

	function loadResults(url, callback = null) {
		if (_isLoading) {
			return;
		}

		$(filterNav).addClass('is-loading');
		$(filterResults).addClass('is-loading');
		$(filterResults).find('.js-filter-loader').addClass('is-loading');
		_isLoading = true;
		$(window).trigger('products:filter');

		$.get(url)
			.done((data) => {
				const dataNav     = $(data).find(filterNav).html();
				const dataResults = $(data).find(filterResults).html();
				const dataContent = $(data).find(seoText).html();
				const seoTitle    = data.match(/<title[^>]*>([^<]+)<\/title>/)[1];

				if (seoTitle) {
					document.title = seoTitle;
				}

				$(filterNav).html(dataNav);
				$(seoText).html(dataContent);
				$(filterResults).hide().html(dataResults).fadeIn(CONFIG.TIMING.LOADING_FADE_IN);

				// Re-init variation forms
				$(filterResults).find('.variations_form').each(function () {
					$(this).wc_variation_form();
				});
				compareBar.init($('.js-compare-bar'), $('.js-compare-checkbox'));

				$(`html, body, ${filterNav}`).animate({
					scrollTop: 0,
				}, {
					duration: CONFIG.UI.SCROLL_DURATION * 1000,
					easing: 'easeInOutQuad',
				});

			}).fail((jqXHR) => {
				console.log(jqXHR.responseText);

			}).always(() => {
				_isLoading = false;
				$(filterNav).removeClass('is-loading');
				$(filterResults).removeClass('is-loading');
				common.init();
				initFilters();
				initNavCollapse();
				ProductPreselect.init($(filterResults));
				FilterCarousel.init($('.js-filter-carousel'));

				$(window).trigger('products:reload');

				if (filterIsOpen) {
					toggleFilterNav();
				}

				if (callback) {
					callback();
				}
			});
	}

	function onPopState(e) {
		if (e.state) {
			_currentState = e.state;

			// Immediately load the page
			if (_isLoading) {
				window.location.href = e.state.href;
			} else {
				// Don't addToHistory here!
				loadResults(e.state.href);
			}
		}
	}

	function getFilterLink(state) {
		const filterSlugs = Object.values(state).reduce((slugs, filter) => {
			if (filter.length > 0) {
				slugs = [...slugs, ...filter];
			}

			return slugs;
		}, []);

		if ((filterSlugs.length == 1) && filterLinks[filterSlugs[0]]) {
			return filterLinks[filterSlugs[0]]
		}

		return false;
	}

	function constructFilterUrl(state) {
		let parameters = [];
		let path       = '';

		filterOrder.forEach(key => {
			if (state[key] && state[key].length) {
				if (key === 'orderby') {
					parameters.push(`${key}=${state[key]}`);
				} else {
					parameters.push(`${key}=${encodeURIComponent(state[key].join('+'))}`);
				}
			}
		});

		return `${window.theme.shop_url}${path}${parameters.length > 0 ? `?${parameters.join('&')}` : ''}`;
	}

	function addToHistory(page_url, page_title) {
		_currentState = {
			href : page_url,
			title: page_title,
			id   : _currentState.id + 1
		};

		window.history.pushState(_currentState, page_title, page_url);
		document.title = page_title;
	}

	return {
		init
	};
})();



